export interface LoadingProps {
  label?: string;
  /** 骨架行数 */
  rows?: number;
}

/** 加载态（每个数据页面都必须有）。带 role=status 便于读屏软件感知。 */
export function Loading({ label = '正在加载…', rows = 3 }: LoadingProps) {
  const count = Math.max(1, Math.min(6, rows));
  const lines = Array.from({ length: count }, (_, index) => index);
  return (
    <div className="loading" role="status" aria-live="polite">
      <div className="loading-line">
        <span className="btn-spinner" aria-hidden="true" />
        <span>{label}</span>
      </div>
      {lines.map((index) => (
        <div key={index} className="skeleton" style={{ width: `${Math.max(35, 100 - index * 14)}%` }} />
      ))}
    </div>
  );
}